module.exports = __webpack_public_path__ + "static/img/shuiLun.778366c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LunBo/shuiLun.jpg
// module id = 3tqG
// module chunks = 0